import { Record } from 'immutable';
import ContentType from '../ContentType';

const MonthlyPayrollRecord = Record({
  id: null,
  comments: null,
  created: null,
  updated: null,
  amount: null,
  month: null,
  year: null,
  payroll: null,
});

class MonthlyPayroll extends MonthlyPayrollRecord {
  static contentType = ContentType.PAY;

  get getId() {
    return this.get('id');
  }
}

export default MonthlyPayroll;
